import * as tslib_1 from "tslib";
import React from 'react';
import classNames from 'classnames';
import styled, { css } from '../styles';
import keycode from 'keycode';
import ArrowDropDown from '../internal/svg-icons/ArrowDropDown';
import SelectWrapper from './SelectWrapper';
import BorderlessSelectWrapper from './BorderlessSelectWrapper';
import { MenuListItem, Menu } from '../Menu';
var disabledStyle = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  cursor: default;\n"], ["\n  cursor: default;\n"])));
var selectStyle = css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  min-width: ", "px;\n  -webkit-appearance: none;\n  user-select: none;\n  padding: ", ";\n  height: 19px;\n  padding-right: ", "px;\n  width: calc(100% - ", "px);\n  cursor: ", ";\n  border: 0px;\n  box-sizing: content-box;\n  background: transparent;\n  font-size: ", "rem;\n  font-family: ", ";\n  border-radius: 0;\n  outline: none;\n  ", ";\n\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n\n  &::-ms-expand {\n    display: none;\n  }\n"], ["\n  min-width: ", "px;\n  -webkit-appearance: none;\n  user-select: none;\n  padding: ", ";\n  height: 19px;\n  padding-right: ",
    "px;\n  width: calc(100% - ", "px);\n  cursor: ", ";\n  border: 0px;\n  box-sizing: content-box;\n  background: transparent;\n  font-size: ", "rem;\n  font-family: ", ";\n  border-radius: 0;\n  outline: none;\n  ", ";\n\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n\n  &::-ms-expand {\n    display: none;\n  }\n"])), function (props) { return props.minWidth || 120; }, function (props) { return (props.borderless ? '2px 0 3px' : '6px 0 7px'); }, function (props) {
    return props.readOnly ? 0 : props.theme.spacing.unit * (props.dense ? 3 : 4);
}, function (props) { return props.theme.spacing.unit * 4; }, function (props) { return (props.readOnly ? 'default' : 'pointer'); }, function (props) { return props.theme.typography.subheading.fontSize; }, function (props) { return props.theme.typography.fontFamily; }, function (props) { return props.multiple && 'max-width: 160px'; });
var menuSelectStyle = css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  line-height: 19px;\n"], ["\n  width: auto;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  line-height: 19px;\n"])));
var StyleSelect = styled.select(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), selectStyle, function (props) { return props.disabled && disabledStyle; });
var StyleMenuSelect = styled.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), selectStyle, menuSelectStyle, function (props) { return props.disabled && disabledStyle; });
var Select = /** @class */ (function (_super) {
    tslib_1.__extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
        };
        _this.ignoreNextBlur = false;
        _this.ignoreNextFocus = false;
        _this.isControlled = _this.props.open !== undefined;
        _this.handleElement = function (_a) {
            var event = _a.event, open = _a.open, anchorEl = _a.anchorEl;
            _this.anchorEl = anchorEl;
            if (open && _this.props.onOpen) {
                _this.props.onOpen();
            }
            else if (!open && _this.props.onClose) {
                _this.props.onClose();
            }
        };
        _this.update = _this.isControlled
            ? _this.handleElement
            : function (_a) {
                var open = _a.open, anchorEl = _a.anchorEl;
                _this.anchorEl = anchorEl;
                _this.setState({
                    open: open,
                });
            };
        _this.handleClick = function (event) {
            event.persist();
            _this.ignoreNextBlur = true;
            _this.update({
                open: true,
                anchorEl: event.currentTarget,
                event: event,
            });
        };
        _this.handleClose = function () {
            _this.focusSelect();
            _this.update({
                open: false,
                anchorEl: _this.anchorEl,
            });
        };
        _this.focusSelect = function () {
            _this.ignoreNextFocus = true;
            _this.anchorEl.focus();
        };
        // tslint:disable-next-line:no-any
        _this.handleItemClick = function (child) { return function (event) {
            if (_this.props.readOnly) {
                return;
            }
            if (!_this.props.multiple) {
                _this.focusSelect();
                _this.update({
                    open: false,
                    anchorEl: _this.anchorEl,
                    event: event,
                });
            }
            if (_this.props.onChange) {
                var _a = _this.props, onChange = _a.onChange, name_1 = _a.name;
                var value = void 0;
                var target = void 0;
                if (event.target) {
                    target = event.target;
                }
                if (_this.props.multiple) {
                    value = _this.props.value;
                    var isArray = Array.isArray(_this.props.value);
                    value = isArray
                        ? value
                            ? value.slice() : []
                        : value
                            ? value.split(',')
                            : [];
                    var itemIndex = value ? value.indexOf(child.props.value) : -1;
                    if (itemIndex === -1) {
                        value.push(child.props.value);
                    }
                    else {
                        value.splice(itemIndex, 1);
                    }
                    if (!isArray) {
                        value = value.join(',');
                    }
                }
                else {
                    value = child.props.value;
                }
                event.persist();
                event.target = tslib_1.__assign({}, target, { value: value, name: name_1 });
                onChange(event, value);
                _this.syncMenuWidth();
            }
        }; };
        _this.handleKeyDown = function (event) {
            if (_this.props.readOnly) {
                return;
            }
            if (['space', 'up', 'down'].includes(keycode(event.nativeEvent))) {
                event.preventDefault();
                _this.ignoreNextBlur = true;
                _this.update({
                    open: true,
                    anchorEl: event.currentTarget,
                    event: event,
                });
            }
        };
        _this.handleBlur = function (event) {
            if (_this.props.readOnly) {
                return;
            }
            if (_this.ignoreNextBlur === true) {
                // The parent components are relying on the bubbling of the event.
                event.stopPropagation();
                _this.ignoreNextBlur = false;
                return;
            }
            if (_this.props.onBlur) {
                event.target.value = _this.props.value;
                _this.props.onBlur(event);
            }
        };
        _this.handleOnFocus = function (event) {
            if (_this.props.readOnly) {
                return;
            }
            if (_this.ignoreNextFocus === true) {
                // The parent components are relying on the bubbling of the event.
                event.stopPropagation();
                _this.ignoreNextFocus = false;
                return;
            }
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        return _this;
    }
    Select.prototype.componentDidMount = function () {
        this.syncMenuWidth();
    };
    Select.prototype.syncMenuWidth = function () {
        var _this = this;
        requestAnimationFrame(function () {
            var anchorElement = _this.anchorEl;
            var targetElement = _this.menuPaper;
            if (anchorElement && targetElement) {
                targetElement.style.minWidth = anchorElement.clientWidth + "px";
            }
        });
    };
    Select.prototype.render = function () {
        var _this = this;
        var _a = this.props, autoWidth = _a.autoWidth, children = _a.children, disabled = _a.disabled, displayEmpty = _a.displayEmpty, _b = _a.MenuProps, MenuProps = _b === void 0 ? {} : _b, multiple = _a.multiple, name = _a.name, error = _a.error, native = _a.native, onBlur = _a.onBlur, onFocus = _a.onFocus, open = _a.open, readOnly = _a.readOnly, renderValue = _a.renderValue, value = _a.value, style = _a.style, className = _a.className, minWidth = _a.minWidth, _c = _a.wrapperStyle, wrapperStyle = _c === void 0 ? {} : _c, wrapperClassName = _a.wrapperClassName, iconHidden = _a.iconHidden, other = tslib_1.__rest(_a, ["autoWidth", "children", "disabled", "displayEmpty", "MenuProps", "multiple", "name", "error", "native", "onBlur", "onFocus", "open", "readOnly", "renderValue", "value", "style", "className", "minWidth", "wrapperStyle", "wrapperClassName", "iconHidden"]);
        if (native) {
            return (React.createElement(SelectWrapper, { disabled: disabled, error: error, readOnly: readOnly, icon: !iconHidden ? React.createElement(ArrowDropDown, null) : React.createElement(React.Fragment, null), style: wrapperStyle, className: wrapperClassName, color: this.props.color },
                React.createElement(StyleSelect, tslib_1.__assign({}, this.props))));
        }
        var display;
        var displaySingle = '';
        var displayMultiple = [];
        var computeDisplay = false;
        // No need to display any value if the field is empty.
        if ((value !== null &&
            value !== undefined &&
            !(Array.isArray(value) && value.length === 0)) ||
            displayEmpty) {
            if (renderValue) {
                display = renderValue(value);
            }
            else {
                computeDisplay = true;
            }
        }
        var items = React.Children.map(children, function (child, index) {
            if (!React.isValidElement(child)) {
                return null;
            }
            var selected;
            if (multiple) {
                // if (!Array.isArray(value)) {
                //   throw new Error(
                //     'Sino-UI: the `value` property must be an array ' +
                //       'when using the `Select` component with `multiple`.',
                //   );
                // }
                var valueArray = [];
                if (value && typeof value === 'string') {
                    valueArray = value.split(',');
                }
                else {
                    valueArray = value;
                }
                selected = valueArray
                    ? valueArray.findIndex(function (item) { return item === child.props.value; }) !== -1
                    : false;
                if (selected && computeDisplay) {
                    displayMultiple.push(child.props.title || child.props.children);
                }
            }
            else {
                selected = value === child.props.value;
                if (selected && computeDisplay) {
                    displaySingle = (child.props.title ||
                        child.props.children);
                }
            }
            return (React.createElement(MenuListItem, tslib_1.__assign({ role: "option" }, child.props, { key: child.props.key || index, selected: selected, onClick: _this.handleItemClick(child) })));
        });
        if (computeDisplay) {
            display = multiple ? displayMultiple.join(', ') : displaySingle;
        }
        var Wrapper = this.props.borderless
            ? BorderlessSelectWrapper
            : SelectWrapper;
        return (React.createElement(React.Fragment, null,
            React.createElement(Wrapper, { key: "select-wrapper", disabled: disabled, readOnly: readOnly, error: error, icon: !iconHidden ? (this.props.icon || React.createElement(ArrowDropDown, null)) : (React.createElement(React.Fragment, null)), style: wrapperStyle, className: wrapperClassName, syncIconColor: this.props.syncIconColor, color: this.props.color, onClick: this.props.onClick },
                React.createElement(StyleMenuSelect, { className: classNames('sinoui-select__content', className), dense: this.props.dense, "aria-pressed": this.state.open ? 'true' : 'false', tabIndex: disabled ? null : 0, role: "button", "aria-owns": this.state.open ? "menu-" + (name || '') : null, "aria-haspopup": "true", onBlur: this.handleBlur, onFocus: this.handleOnFocus, disabled: disabled, multiple: multiple, readOnly: readOnly, minWidth: minWidth, style: tslib_1.__assign({}, style, this.props.textStyle), innerRef: function (node) {
                        _this.anchorEl = node;
                    }, onClick: disabled || readOnly ? null : this.handleClick, onKeyDown: this.handleKeyDown, borderless: this.props.borderless }, display || this.props.content)),
            React.createElement(Menu, tslib_1.__assign({ dense: this.props.dense, minWidth: this.anchorEl ? this.anchorEl.clientWidth : 0, paperRef: function (menuPaper) { return (_this.menuPaper = menuPaper); }, key: "select-menu", id: "menu-" + (name || ''), anchorEl: this.anchorEl, open: this.isControlled ? open : this.state.open, onRequestClose: this.handleClose }, MenuProps, { MenuListProps: tslib_1.__assign({}, MenuProps.MenuListProps, { role: 'listbox' }), anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                }, color: this.props.color, textStyle: this.props.textStyle }), items)));
    };
    return Select;
}(React.PureComponent));
export default Select;
export { StyleMenuSelect };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Select.js.map